import { initialStateInterface } from "../interfaces/firmaInterfaces";
import { firmaElectronicaTypes } from "../types/firmaElectronicaTypes";

export const FirmaElectronicaReducer = (
  state: initialStateInterface,
  { type, payload }: any
) => {
  switch (type) {
    case firmaElectronicaTypes.add_cert_file:
      return {
        ...state,
        certFile: payload,
      };
    case firmaElectronicaTypes.add_key_file:
      return {
        ...state,
        keyFile: payload,
      };
    case firmaElectronicaTypes.add_tipo_firmante:
      return {
        ...state,
        tipo_firmante: payload,
      };
    case firmaElectronicaTypes.show_password:
      return {
        ...state,
        showPassword: !state.showPassword,
      };
    case firmaElectronicaTypes.loading_firma:
      return {
        ...state,
        loadingFirma: payload,
      };
    case firmaElectronicaTypes.add_password:
      return {
        ...state,
        password: payload,
      };
    case firmaElectronicaTypes.add_error_messages:
      return {
        ...state,
        errorMessage: payload,
      };
    case firmaElectronicaTypes.add_str_certificate:
      return {
        ...state,
        strCertificate: payload,
      };
    case firmaElectronicaTypes.add_digestiones:
      return {
        ...state,
        digestiones: payload,
      };
    case firmaElectronicaTypes.add_str_cert_pem:
      return {
        ...state,
        strCerPem: payload,
      };
    case firmaElectronicaTypes.add_str_private_key:
      return {
        ...state,
        strPrivateKey: payload,
      };
    case firmaElectronicaTypes.add_o_private_key:
      return {
        ...state,
        oPrivateKey: payload,
      };
    case firmaElectronicaTypes.add_status_firma:
      return {
        ...state,
        statusFirma: payload,
      };
    case firmaElectronicaTypes.add_der_response_data:
      return {
        ...state,
        derResData: payload,
      };
    case firmaElectronicaTypes.add_vector_response_data:
      return {
        ...state,
        vectorResData: payload,
      };
    case firmaElectronicaTypes.add_algoritmo_digestion:
      return {
        ...state,
        algoritmoDigestion: payload,
      };
    case firmaElectronicaTypes.add_iteraciones_encontradas:
      return {
        ...state,
        iteracionesEncontradas: payload,
      };
    case firmaElectronicaTypes.is_success_firmado:
      return {
        ...state,
        successFirmado: payload,
      };
    case firmaElectronicaTypes.show_cer_key_save:
      return {
        ...state,
        showCertificadosGuardados: payload,
      };
    case firmaElectronicaTypes.add_list_firmantes:
      return {
        ...state,
        listFirmantes: payload,
        successFirmado: false,
      };
    case firmaElectronicaTypes.cer_selected:
      return {
        ...state,
        cerSelected: payload,
      };
    case firmaElectronicaTypes.key_selected:
      return {
        ...state,
        keySelected: payload,
      };
    case firmaElectronicaTypes.change_step_firma:
      return {
        ...state,
        stepsFirmas: payload,
      };
    case firmaElectronicaTypes.reset_state_error:
      return {
        ...state,
        digestiones: [],
        statusFirma: null,
        derResData: [],
        vectorResData: [],
        iteracionesEncontradas: [],
        algoritmoDigestion: null,
        strCerPem: null,
        strCertificate: "",
        strPrivateKey: "",
        oPrivateKey: "",
        tipo_firmante: null,
        certFile: null,
        keyFile: null,
        password: "",
        showPassword: false,
        loadingFirma: false,
        showCertificadosGuardados: false,
        cerSelected: null,
        keySelected: null,
        stepsFirmas: {
          paso1: state.stepsFirmas.paso1 ? true : false,
          paso2: false,
          paso3: false,
          paso4: false,
          paso5: false,
          paso6: false,
          paso7: false,
        },
      };
    case firmaElectronicaTypes.reset_state_success:
      return {
        ...state,
        cerSelected: null,
        keySelected: null,
        digestiones: [],
        statusFirma: null,
        errorMessage: [],
        derResData: [],
        vectorResData: [],
        iteracionesEncontradas: [],
        algoritmoDigestion: null,
        strCerPem: null,
        strCertificate: "",
        strPrivateKey: "",
        oPrivateKey: "",
        tipo_firmante: null,
        certFile: null,
        keyFile: null,
        password: "",
        showPassword: false,
        loadingFirma: false,
        showCertificadosGuardados: false,
        stepsFirmas: {
          paso1: state.stepsFirmas.paso1 ? true : false,
          paso2: false,
          paso3: false,
          paso4: false,
          paso5: false,
          paso6: false,
          paso7: false,
        },
      };

    default:
      return state;
  }
};
